import moment from "moment";
import { Fragment, useState } from "react";
import { amountInWords } from "../../_helper/utils/utils";

const InvoicePrint = ({ headerUrl, pdfData, invoice_data }) => {
  //("RUNEDDDDD");
  const [invoiceData, setInvoiceData] = useState(pdfData);
  const billType = invoiceData?.bill_type;
  const patienName = invoiceData?.patient_details?.full_name;
  const billNo = invoiceData?.invoice_no;
  const bill_type = {
    IPD: invoiceData?.admission_details?.IPD_No,
    OPD: invoice_data?.opd?.opd_number,
  };
  const DOA = `${moment(invoiceData?.admission_details?.admission_date).format(
    "DD-MMM-YYYY"
  )} at ${invoiceData?.admission_details?.admission_time}`;
  const DOD = `${moment(invoiceData?.admission_details?.discharge_date).format(
    "DD-MMM-YYYY"
  )} at ${invoiceData?.admission_details?.discharge_time}`;
  const opdTime = invoice_data?.opd?.date;
  const amountInWord =
    invoiceData?.amount_in_word || amountInWords(invoiceData?.invoice_total);
  const invoiceDate = moment(invoiceData?.invoice_date).format("DD-MMM-YYYY");
  const injury_no = invoiceData?.admission_details?.injury_no;
  const customerName =
    invoice_data?.institution_customer?.institution_name || "";
  const diagnosis = invoice_data?.admission_details?.diagnosis;
  const treatment = invoice_data?.admission_details?.treatment;

  //("INVOOCIEPRINT", pdfData);

  return (
    <div
      style={{
        width: "21cm",
        height: "29.7cm",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          width: "80%",
          height: "80%",
          padding: "13px 10px 0 10px",
        }}
      >
        <div style={{ width: "100%" }}>
          <img src={headerUrl} style={{ width: "100%" }} />
        </div>
        <div
          style={{
            border: "1px solid rgba(0, 0, 0, 0.8)",
            borderRadius: "4px",
            textAlign: "center",
            padding: "8px 0 8px 0",
            fontWeight: "700",
            fontSize: "22px",
            lineHeight: "24px",
            color: "#000000",
          }}
        >
          {billType} Billing Summary
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            {customerName && <div>{`Customer: ${customerName}`}</div>}
            <div>{`Patient Name: Mr. ${patienName}`}</div>
            <div>{`Bill No: ${billNo}`}</div>
            <div>{`Invoice Date: ${invoiceDate}`}</div>
          </div>
          <div>
            <div>{`${billType} No: ${bill_type[billType]}`}</div>
            {injury_no && <div>{`Injury Slip No: ${injury_no}`}</div>}
            {billType === "IPD" && <div>{`DOA: ${DOA}`}</div>}
            {billType === "IPD" && <div>{`DOD: ${DOD}`}</div>}
            {billType === "OPD" && <div>{`OPD Date: ${opdTime}`}</div>}
          </div>
        </div>
        <div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              border: "1px solid #000000cc",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    fontWeight: "700",
                    fontSize: "15px",
                    lineHeight: "13px",
                    padding: "10px 3px 10px 3px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    textAlign: "start",
                  }}
                >
                  Description
                </th>
                <th
                  style={{
                    fontWeight: "700",
                    fontSize: "15px",
                    lineHeight: "13px",
                    padding: "10px 3px 10px 3px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    textAlign: "start",
                  }}
                >
                  Qty
                </th>
                <th
                  style={{
                    fontWeight: "700",
                    fontSize: "15px",
                    lineHeight: "13px",
                    padding: "10px 3px 10px 3px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    textAlign: "start",
                  }}
                >
                  Rate/Package
                </th>
                <th
                  style={{
                    fontWeight: "700",
                    fontSize: "15px",
                    lineHeight: "13px",
                    padding: "10px 3px 10px 3px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    textAlign: "start",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceData?.invoice_lines?.map((invcSer, pkgIdx) => {
                if (invcSer?.line_package) {
                  return invcSer?.line_package?.services?.map(
                    (pkgSer, pkgSerIdx) => {
                      return (
                        <tr
                          key={`${pkgSer?.clinic_services_id?.id}${pkgSerIdx}`}
                        >
                          <td
                            style={{
                              padding: "5px 0 5px 3px",
                              fontSize: "13px",
                              lineHeight: "14px",
                              color: "#000000",
                              borderRight: "1px solid #000000cc",
                              borderBottom: "1px solid #000000cc",
                            }}
                          >
                            {pkgSer?.name_of_service}
                          </td>
                          <td
                            style={{
                              padding: "5px 0 5px 3px",
                              fontSize: "13px",
                              lineHeight: "14px",
                              color: "#000000",
                              borderRight: "1px solid #000000cc",
                              borderBottom: "none",
                            }}
                          >
                            {pkgSerIdx ===
                            Math.ceil(
                              invcSer?.line_package?.services?.length / 2
                            ) -
                              1
                              ? invcSer?.quantity || 0
                              : ""}
                          </td>
                          <td
                            style={{
                              padding: "5px 0 5px 3px",
                              fontSize: "13px",
                              lineHeight: "14px",
                              color: "#000000",
                              borderRight: "1px solid #000000cc",
                              borderBottom: "none",
                            }}
                          >
                            {pkgSerIdx ===
                            Math.ceil(
                              invcSer?.line_package?.services?.length / 2
                            ) -
                              1
                              ? invcSer?.line_package?.name_of_package
                              : ""}
                          </td>
                          {pkgSerIdx ===
                            Math.ceil(
                              invcSer?.line_package?.services?.length / 2
                            ) -
                              1 && (
                            <td
                              style={{
                                padding: "5px 0 5px 3px",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color: "#000000",
                                borderRight: "1px solid #000000cc",
                                borderBottom: "none",
                              }}
                            >{`Rs ${invcSer?.total}`}</td>
                          )}
                        </tr>
                      );
                    }
                  );
                } else if (
                  invcSer?.line_service?.name_of_service?.toUpperCase() ===
                    "MEDICINE CHARGE" ||
                  invcSer?.line_service?.name_of_service?.toUpperCase() ===
                    "MEDICINE CHARGES"
                ) {
                  return (
                    <Fragment key={`${invcSer?.line_service?.id}${pkgIdx}`}>
                      <tr>
                        <td
                          style={{
                            padding: "5px 0 5px 3px",
                            fontSize: "13px",
                            lineHeight: "14px",
                            color: "#000000",
                            borderRight: "1px solid #000000cc",
                            borderBottom: "1px solid #000000cc",
                          }}
                        >
                          <b>{invcSer?.line_service?.name_of_service}</b>
                        </td>
                        <td
                          style={{
                            padding: "5px 0 5px 3px",
                            fontSize: "13px",
                            lineHeight: "14px",
                            color: "#000000",
                            borderRight: "1px solid #000000cc",
                            borderBottom: "1px solid #000000cc",
                          }}
                        >
                          <b>
                            {invcSer?.type === "Qty" ? invcSer?.quantity : "-"}
                          </b>
                        </td>
                        <td
                          style={{
                            padding: "5px 0 5px 3px",
                            fontSize: "13px",
                            lineHeight: "14px",
                            color: "#000000",
                            borderRight: "1px solid #000000cc",
                            borderBottom: "1px solid #000000cc",
                          }}
                        >
                          <b>
                            {Number(invcSer?.price) > 0 ? invcSer?.price : "-"}
                          </b>
                        </td>
                        <td
                          style={{
                            padding: "5px 0 5px 3px",
                            fontSize: "13px",
                            lineHeight: "14px",
                            color: "#000000",
                            borderRight: "1px solid #000000cc",
                            borderBottom: "1px solid #000000cc",
                          }}
                        >
                          <b>{`-`}</b>
                        </td>
                      </tr>
                      {invcSer?.sub_lines?.map((subline, subIdx) => {
                        return (
                          <tr style={{ fontSize: "12px" }} key={subIdx}>
                            <td
                              style={{
                                padding: "5px 0 5px 3px",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color: "#000000",
                                borderRight: "1px solid #000000cc",
                                borderBottom: "1px solid #000000cc",
                              }}
                            >
                              {`${subline?.medicine_name} `}
                              {subline?.generic_name === "nan" ||
                              !subline?.generic_name
                                ? ""
                                : `(${subline?.generic_name})`}
                              {subline?.batch_no?.map((ele) => {
                                if (ele?.consumed_qty > 0) {
                                  return (
                                    <div
                                      style={{ fontSize: "11.5px" }}
                                      key={ele?.batchId}
                                    >{`Batch No: ${ele?.batchNo}, Qty: ${
                                      ele?.consumed_qty
                                    }, expiry: ${moment(ele?.expiry).format(
                                      "DD MMM YYYY"
                                    )}`}</div>
                                  );
                                }
                              })}
                            </td>
                            <td
                              style={{
                                padding: "5px 0 5px 3px",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color: "#000000",
                                borderRight: "1px solid #000000cc",
                                borderBottom: "1px solid #000000cc",
                              }}
                            >
                              {subline?.quantity || 0}
                            </td>
                            <td
                              style={{
                                padding: "5px 0 5px 3px",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color: "#000000",
                                borderRight: "1px solid #000000cc",
                                borderBottom: "1px solid #000000cc",
                              }}
                            >
                              {subline?.price}
                            </td>
                            <td
                              style={{
                                padding: "5px 0 5px 3px",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color: "#000000",
                                borderRight: "1px solid #000000cc",
                                borderBottom: "1px solid #000000cc",
                              }}
                            >{`Rs ${
                              Number(subline?.price) * Number(subline?.quantity)
                            }`}</td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  );
                } else {
                  return (
                    <tr key={`${invcSer?.line_service?.id}${pkgIdx}`}>
                      <td
                        style={{
                          padding: "5px 0 5px 3px",
                          fontSize: "13px",
                          lineHeight: "14px",
                          color: "#000000",
                          borderRight: "1px solid #000000cc",
                          borderBottom: "1px solid #000000cc",
                        }}
                      >
                        {invcSer?.line_service?.name_of_service}
                      </td>
                      <td
                        style={{
                          padding: "5px 0 5px 3px",
                          fontSize: "13px",
                          lineHeight: "14px",
                          color: "#000000",
                          borderRight: "1px solid #000000cc",
                          borderBottom: "1px solid #000000cc",
                          borderTop: "1px solid #000000cc",
                        }}
                      >
                        {invcSer?.type === "Qty" ? invcSer?.quantity : "-"}
                      </td>
                      <td
                        style={{
                          padding: "5px 0 5px 3px",
                          fontSize: "13px",
                          lineHeight: "14px",
                          color: "#000000",
                          borderRight: "1px solid #000000cc",
                          borderBottom: "1px solid #000000cc",
                          borderTop: "1px solid #000000cc",
                        }}
                      >
                        {Number(invcSer?.price) > 0 ? invcSer?.price : "-"}
                      </td>
                      <td
                        style={{
                          padding: "5px 0 5px 3px",
                          fontSize: "13px",
                          lineHeight: "14px",
                          color: "#000000",
                          borderRight: "1px solid #000000cc",
                          borderBottom: "1px solid #000000cc",
                          borderTop: "1px solid #000000cc",
                        }}
                      >{`Rs ${invcSer?.total}`}</td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td
                  style={{
                    padding: "5px 0 5px 3px",
                    fontSize: "13px",
                    lineHeight: "14px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                  }}
                ></td>
                <td
                  style={{
                    padding: "5px 0 5px 3px",
                    fontSize: "13px",
                    lineHeight: "14px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                  }}
                ></td>
                <td
                  style={{
                    padding: "5px 0 5px 3px",
                    fontSize: "13px",
                    lineHeight: "14px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    borderTop: "1px solid #000000cc",
                    fontWeight: "700",
                  }}
                >
                  Total
                </td>
                <td
                  style={{
                    padding: "5px 0 5px 3px",
                    fontSize: "13px",
                    lineHeight: "14px",
                    color: "#000000",
                    borderRight: "1px solid #000000cc",
                    borderBottom: "1px solid #000000cc",
                    borderTop: "1px solid #000000cc",
                    fontWeight: "700",
                  }}
                >{`Rs ${invoiceData?.invoice_total}`}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ fontSize: "13px" }}>
          <b>Total Amount in words:</b>
          {` ${amountInWord} Only.`}
        </div>
        {diagnosis && (
          <div style={{ fontSize: "13px" }}>
            <b>Diagnosis:</b>
            {` ${diagnosis}`}
          </div>
        )}
        {treatment && (
          <div style={{ fontSize: "13px" }}>
            <b>Treatment:</b>
            {` ${treatment}`}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoicePrint;
